// shared lookup tables/helpers used by both MembersView (filters/table) and
// MemberDetailDialog (read-only detail popup) so the option lists only need
// to be maintained in one place
export interface LabelledOption {
  label: string
  value: string
}

export const ACCOUNT_STATUS_OPTIONS: Array<LabelledOption> = [
  {label: "Active", value: "ACT"},
  {label: "Inactive", value: "INA"},
  {label: "Pending", value: "PND"},
  {label: "Locked", value: "LCK"},
  {label: "Expired", value: "EXP"},
]

export const MFA_TYPE_OPTIONS: Array<LabelledOption> = [
  {label: "Email OTP", value: "EmlOtp"},
  {label: "SMS OTP", value: "SmsOtp"},
  {label: "Authenticator (TOTP)", value: "AtTotp"},
  {label: "Microsoft (Push)", value: "MsPush"},
]
export const CLASSIFICATION_OPTIONS: Array<LabelledOption> = [
  {label: "Standard", value: "STD"},
  {label: "Police", value: "POL"},
  {label: "PAM", value: "PAM"},
]

export const CONTRIBUTION_STATUS_OPTIONS: Array<LabelledOption> = [
  {label: "Active", value: "ACT"},
  {label: "Preserved", value: "PRE"},
  {label: "Closed", value: "CLS"},
]

export const BENEFICIARY_NOMINATION_OPTIONS: Array<string> = [
  "LPR",
  "Spouse",
  "Child",
  "Interdependency",
  "Dependant",
  "Partner",
  "Family",
  "Unknown",
  "Other",
]

export const optionLabel = (options: Array<LabelledOption>, value: string | null): string =>
  options.find(o => o.value === value)?.label ?? (value == null || value === "" ? "-" : value)
